import React from "react";
import {
  EnvelopeSimple,
  GithubLogo,
  LinkedinLogo,
  Phone,
} from "phosphor-react";
import ProfileImage from "../../../assets/profile.jpg";
import Resume from "../../../assets/resume.pdf";

const AvatarCard = () => (
  <div className="flex h-min flex-col items-center overflow-hidden rounded-t-lg bg-cards px-8 py-6 shadow-xl lg:max-w-xs lg:rounded-lg">
    <img
      className="mb-4 inline h-48 w-48 rounded-full object-cover"
      src={ProfileImage}
      alt="Profile image"
    />
    <div className="flex flex-col justify-center">
      <h1 className="mb-1 text-center text-3xl font-semibold tracking-tight text-gray-800">
        Ali Ciftci
      </h1>
      <h1 className="mb-5 text-center text-xl font-medium tracking-tight text-gray-800">
        Front-End Web Developer
      </h1>
      <div className="mb-5 flex justify-center gap-x-5">
        <a href="https://www.linkedin.com/in/aliciftci/">
          <LinkedinLogo size={28} cursor="pointer" />
        </a>
        <a href="https://github.com/Kalandri">
          <GithubLogo size={28} cursor="pointer" />
        </a>

        <Phone size={28} cursor="pointer" />
        <EnvelopeSimple size={28} cursor="pointer" />
      </div>
      <a
        href={Resume}
        className="flex h-10 items-center justify-center rounded-full border-2 border-gray-700 hover:border-red hover:bg-red hover:text-white"
      >
        Download Resume
      </a>
    </div>
  </div>
);

export default AvatarCard;
